const features = {
    /** Stale Flag */
    smagButton: false,
    /** Stale Flag */
    additionalAggregates: false,
    /** Billing contacts menu */
    billingContacts: false,
    /** use d3 as engine to produce chart */
    chartWithD3: true,
    /** Option to share sensor within organization */
    shareSensorOption: false,
    /** All redesign related changes */
    redesign: true,
    /** Weather redesign - forecasts page changes */
    wr_forecasts: false,
    /** Weather redesign - weather dashboard changes */
    wr_dashboard: false,
    /** Distance unit preference */
    distance_unit: false
};
export const defaultFeature = features;
